<template>
  <div style="margin-top:-10px !important">
    <b-row class="px-pad border-bottom" style="height:42px">
      <b-col md="6" lg="6" sm="6" cols="6" class="px-0">
        <span class="fw-semi-bold index-heading pl-0">Currencies</span>
      </b-col>
      <b-col md="6" lg="6" sm="6" cols="6" class="text-right px-0">
        <b-button
          variant="primary"
          size="sm"
          @click="currency_detail =createFreshData();page='create'"
          v-b-modal.currencymodal
        >New Currency</b-button>
        <b-button
          variant="light"
          size="sm"
          class="ml-2"
          v-b-modal.exchangeratechange
        >{{exchange_status==1?'Enable Exchange rates':'Disable Exchange rates'}}</b-button>
        <b-dropdown size="sm" variant="light">
          <b-dropdown-item :to="{name:'ExchangeRateImport'}">
            <span class="no_caret_import la la-upload mr-3"></span>Import Ex.Rate
          </b-dropdown-item>
          <b-dropdown-item @click="exportModal()">
            <span class="no_caret_import la la-download mr-3"></span>
            Export Ex.Rate
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <!-- Table for details -->
    <b-row>
      <b-col cols="12" class="px-0">
        <div class="table-responsive px-0">
          <table class="table table-hover not-fixed-col not-fixed-last-col index-table">
            <thead>
              <tr>
                <th class="text-left" style="padding-left:1.6rem !important">Name</th>
                <th style="width:100px" class="text-left">Symbol</th>
                <template v-if="exchange_status==1">
                  <th style="width:200px" class="text-right">EXCHANGE RATE (IN {{orgCurrency}})</th>
                  <th style="width:150px" class="text-left">AS OF DATE</th>
                </template>
                <th style="width:50px;padding-right:1.6rem !important" class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(currency,index) in lists " :key="index">
                <td style="padding-left:1.6rem !important">
                  <span
                    class="text-primary cursor_pointer"
                    @click="fetchCurrencyDetails(currency.currency_id);page='update'"
                  >{{currency.currency_name}}</span>
                  <b-badge
                    class="ml-2"
                    v-if="base_currency==currency.currency_id"
                    size="xs"
                    variant="success"
                  >Base Currency</b-badge>
                </td>
                <td>{{currency.currency_symbol}}</td>
                <template v-if="exchange_status==1">
                  <td
                    class="text-right"
                  >{{currency.exchange_rate!=''?Number(currency.exchange_rate).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }):''}}</td>
                  <td>{{getDateFormat(currency.as_of_date)}}</td>
                </template>
                <td class="text-right cursor_pointer" style="padding-right:1.6rem !important">
                  <b-dropdown
                    right
                    toggle-class="text-decoration-none"
                    variant="link"
                    no-caret
                    size="xs"
                    class="table-hover-visible last-td-arrow"
                  >
                    <template slot="button-content">
                      <i
                        class="glyphicon glyphicon-option-vertical theme-text-color"
                        style="top:-6px !important;letter-spacing:-5px !important"
                      ></i>
                    </template>
                    <span
                      class="event-link dropdown-item"
                      @click="fetchCurrencyDetails(currency.currency_id);page='update'"
                    >Edit</span>
                    <b-dropdown-item
                      v-if="exchange_status==1&&base_currency!=currency.currency_id"
                      class="event-link"
                      :to="{name:'ExchangeRate',params:{id:currency.currency_id}}"
                    >View exchange rates</b-dropdown-item>
                    <span
                      v-if="base_currency!=currency.currency_id"
                      v-b-modal.deletecurrency
                      @click="delete_id=currency.currency_id"
                      class="event-link dropdown-item"
                    >Delete</span>
                  </b-dropdown>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-col>
    </b-row>
    <!-- Status change for exchange rate -->
    <b-modal
      :no-close-on-backdrop="true"
      id="exchangeratechange"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      title="Change status exchange rate"
      ref="exchangeratechange"
      :ok-title-html="(submitted==true?loaderIcon:'')+(exchange_status==1?'Enable':'Disable')"
      @ok.prevent="exchangeRateStatus()"
      :ok-disabled="submitted"
    >
      <p
        v-if="exchange_status==0"
      >You will have to manually enter the exchange rates for each currency, if you disable this feature.</p>
      <p v-else>The exchange rates for the currencies will automatically be fetched as 1.</p>
    </b-modal>

    <!--  delete modal -->

    <b-modal
      :no-close-on-backdrop="true"
      id="deletecurrency"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="(submitted==true?loaderIcon:'')+'Yes'"
      title="Delete Currency"
      ref="deletecurrency"
      @ok="deleteCurrency()"
      :ok-disabled="submitted"
    >
      <p>Are you sure about deleting this currency?</p>
    </b-modal>
    <!-- create and update currency modal -->
    <CurrencyModal :page="page" :currency_detail="currency_detail"></CurrencyModal>
    <GlobalExportModal
      v-if="export_modal"
      :data="export_data"
      :columns="export_xl"
      :file_name="'Exchange Rate'"
      @downloaded="export_modal=false"
    />
  </div>
</template>
<script>
// import all the components, files and funciton
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global function for calling notification
import vSelect from "vue-select";
import { formatDate } from "@/mixins/formatDate";
import CurrencyModal from "@/components/Modal/Currency/CurrencyModal"; // to excel export the output

//pages
function getPageList(routeTo, next) {
  store.dispatch("currency/fetchLists").then(() => {
    next();
  });
}
export default {
  components: { vSelect, CurrencyModal },
  mixins: [notificationMixin, formatDate], //call the global mixin function
  name: "ReportTag",
  data() {
    return {
      export_data: [],
      export_modal: false,
      delete_id: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      submitted: false,
      currency_detail: this.createFreshData(),
      page: "create",
      export_xl: {
        "Currency Code": "currency_code",
        Date: "exchange_rate_date",
        "Exchange Rate": "exchange_rate"
      }
    };
  },
  methods: {
    async exportModal() {
      this.export_modal = await true;
      this.export_data = await this.fetchExportData();
      this.$root.$emit("bv::show::modal", "exportdata");
    },
    createFreshData() {
      return {
        id: "",
        code: "",
        symbol: "",
        name: "",
        decimal_places: 2,
        format: 1
      };
    },
    //function for update field for currency field change
    changeCurrency(event) {
      var temp = this;
      this.$AppDetails.currency_list.map(function(value) {
        if (value.currency_code == event) {
          temp.currency_detail.symbol = value.currency_symbol;
          temp.currency_detail.name = value.currency;
          temp.currency_detail.id = value.currency_id;
        }
      });
    },
    fetchCurrencyDetails(id) {
      this.$store.dispatch("currency/fetchCurrencyDetails", id).then(() => {
        this.currency_detail = this.list;
        this.$root.$emit("bv::show::modal", "currencymodal");
      });
    },
    // chanage exchange status
    exchangeRateStatus() {
      this.submitted = true;
      this.$store
        .dispatch("currency/exchangeRateStatus", {
          exchange_status: this.exchange_status == 0 ? 1 : 0
        })
        .then(() => {
          this.submitted = false;
          this.$refs.exchangeratechange.hide();
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.type,
            showCloseButton: true
          });
        });
    },
    // delete currency function
    deleteCurrency() {
      this.submitted = true;
      this.$store
        .dispatch("currency/deletecurrency", {
          id: this.delete_id
        })
        .then(() => {
          //to show the alert message for success or error after api call
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.message,
            type: this.type,
            showCloseButton: true
          });
          store.dispatch("currency/fetchLists");
          this.submitted = false;
        });
    },

    // fetch export data for all currency exchange rate
    async fetchExportData() {
      const response = await store
        .dispatch("currency/fetchexportLists")
        .then(() => {
          return this.export;
        });
      return response;
    },
    startDownload() {
      this.loader = "Loading...";
    },
    finishDownload() {
      this.loader = "Downloaded";
    }
  },
  //routing
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageList(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageList(routeTo, next);
  },
  //computed properties
  computed: {
    ...mapState({
      lists: state => state.currency.lists,
      list: state => state.currency.list,
      message: state => state.currency.message,
      type: state => state.currency.type,
      base_currency: state => state.currency.base_currency,
      exchange_status: state => state.currency.exchange_status,
      export: state => state.currency.export
    }),
    ...mapGetters(["orgCurrency"])
  }
};
</script>